import React from 'react'
import { Link } from 'react-router-dom'

const ThankYou = () => {
    return (
        <section className='thankyou_secc'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-12'>
                        <h1>Order Placed Successfully!</h1>
                        <Link to="/" className="shop-btn">
                            Back To Home <i className="fas fa-arrow-right"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ThankYou